import i18n from '@i18n/i18n';

import React from 'react';

import { ISideBarItem, ITechnicianDataFields, SideBarItemTypes } from './types';

import { ReactComponent as HomeIcon } from 'assets/home.icon.svg';
import { ReactComponent as TicketsIcon } from 'assets/tickets.icon.svg';
import { ReactComponent as ChatsIcon } from 'assets/chats.icon.svg';
import { ReactComponent as InvoicesIcon } from 'assets/invoices.icon.svg';

import { CHATS, HOME, INVOICES, TICKETS } from 'router/routes';
import { Roles } from 'constants/roles';

export const sideBarItems: ISideBarItem[] = [
  {
    id: SideBarItemTypes.Home,
    title: 'sideBar.home',
    icon: <HomeIcon />,
    path: HOME,
    roles: [Roles.User, Roles.AccountingUser, Roles.Admin, Roles.Manager],
  },
  {
    id: SideBarItemTypes.Tickets,
    title: 'sideBar.tickets',
    icon: <TicketsIcon />,
    path: TICKETS,
    roles: [Roles.User, Roles.AccountingUser, Roles.Admin, Roles.Manager],
  },
  {
    id: SideBarItemTypes.Chats,
    title: 'sideBar.chats',
    icon: <ChatsIcon />,
    path: CHATS,
    roles: [Roles.User, Roles.AccountingUser, Roles.Admin, Roles.Manager],
  },
  {
    id: SideBarItemTypes.Invoices,
    title: 'sideBar.invoices',
    icon: <InvoicesIcon />,
    path: INVOICES,
    roles: [Roles.AccountingUser, Roles.Admin, Roles.Manager],
  },
];

export const technicianDataFields: ITechnicianDataFields[] = [
  { label: 'Company Name', name: 'techCompanyName' },
  { label: 'Company Phone', name: 'techPhone' },
  { label: 'On-Call Technician', name: 'techName' },
  { label: 'On-Call Email', name: 'techEmail' },
  { label: 'On-Call Phone Number', name: 'afterHoursTechPhone' },
  { label: 'On-Call SMS', name: 'afterHoursTechEmail' },
];
